const isAbsoluteHttpUrl = (value: string) => /^https?:\/\//i.test(value);

const getApiUrl = () => {
    const isDev = import.meta.env.DEV;

    // 1. Local storage override (useful for debugging)
    // In production, ONLY allow absolute http(s) URLs. A relative "/api" will hit the SPA and return HTML.
    const override = typeof localStorage !== 'undefined' ? localStorage.getItem('VITE_API_URL_OVERRIDE') : null;
    if (override) {
        if (isDev) return override;
        if (isAbsoluteHttpUrl(override)) return override;
        console.warn(`⚠️ Ignoring VITE_API_URL_OVERRIDE in production because it's not an absolute URL: "${override}"`);
    }

    // 2. Development mode uses Vite proxy /api
    if (isDev) {
        return '/api';
    }

    // 3. Explicit environment variable
    if (import.meta.env.VITE_API_URL) {
        const envUrl = String(import.meta.env.VITE_API_URL);
        if (isAbsoluteHttpUrl(envUrl)) return envUrl;
        console.warn(`⚠️ Ignoring VITE_API_URL in production because it's not an absolute URL: "${envUrl}"`);
    }

    // 4. Default Production Fallback (same-origin reverse proxy)
    return '/api';
};

export const API_URL = getApiUrl();

// Log the resolved API URL for debugging purposes
if (typeof console !== 'undefined') {
    console.log(`🔗 API URL resolved to: ${API_URL} (env: ${import.meta.env.DEV ? 'dev' : 'prod'})`);
}
